import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'element-ui/lib/theme-chalk/index.css'
import jquery from 'jquery'
window.$ = jquery
import 'animate.css'
import '@/styles/global.scss' // global css

import 'vue2-toast/lib/toast.css'
import Toast from 'vue2-toast'
Vue.use(Toast, {
  type: 'center',
  duration: 2000,
  wordWrap: true
})

import {
  Divider,
  Row,
  Col,
  Carousel,
  CarouselItem,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  Button,
  Dialog,
  Form,
  FormItem,
  Input,
  Message
} from 'element-ui'
Vue.use(Divider)
Vue.use(Row)
Vue.use(Col)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Button)
Vue.use(Dialog)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)

Vue.prototype.$message = Message

//全局导航钩子
router.beforeEach(async (to, from, next) => {
  if (to.name == 'erjian' || to.name == 'tg4') {
    const link = document.querySelector("link[rel*='icon']") || document.createElement('link')
    link.type = 'image/x-icon'
    link.rel = 'shortcut icon'
    link.href = 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/tg/favicon1.ico'
    document.getElementsByTagName('head')[0].appendChild(link)
  }
  next()
})

//阿里云存储图片全路径
Vue.prototype.$imgsrc = function (src) {
  return 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/pc/' + src
}

import MetaInfo from 'vue-meta-info'

Vue.use(MetaInfo)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
